const getSetting = (settings: any, type: string) => settings.find((setting: any) => setting.id === type)

export default getSetting
